import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { format } from "date-fns";
import { useFormik } from "formik";
import tentStyles from "../TentHouseService.module.css";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import styles from "../PriestManagerService.module.css";
import caterStyles from "./CateringService.module.css";
import config from "../../../config";
import noimage from '../../../assets/images/Desktop placeholder.svg';
import backgroundimage from "../../../assets/images/cateringbackground_image.png";
import ServiceForm from "./ServiceForm";
import nopackageimage from "../../../assets/images/Group 2_11zon.png";

import { confirmDialog } from "primereact/confirmdialog";

import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";

import { fetchServices } from "../../../Apiservices/Auth/servers/fetchServices";
import { getServiceProviderProfile } from "../../../Apiservices/Auth/servers/profileServer";
import "../ServiceProviderDashboard.css";

import {
  updateServiceProviderServices,
  addServiceProviderServices,
  editServiceProviderServices,
  addPriestEventServices,
  deletePriestEventServices,
} from "../../../Apiservices/Auth/servers/updateServiceProviderServices";
import {

  addCateringProviderServices,
  deleteCateringProviderServices,
  getCateringItemMasterList,
  getCateringProviderAddedServices,
  getCateringProviderCategories,
  getCateringProviderCuisines,
  getCateringProviderServices,
  updateCateringProviderServices,
  getimagesidforcateringcusines,
  getCateringCategoryList,
  
} from "../../../Apiservices/Auth/servers/fetchProviderData";
import { fetchCategoryEvents } from '../../../Apiservices/Auth/servers/fetchCategoryEvents';
import CollapseExpandTree from "../../CustomComponents/CollapseExpandTree";

import {
  searchSelectCateringText,
  searchSelectEventText,
} from "../../../constant";

function CateringService(prop) {
  console.log('🔄 CateringService rendering');

  const [includedItems, setIncludedItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allMasterItems, setAllMasterItems] = useState([]);
  const [sidessallMasterItems, sidessetAllMasterItems] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);

  const [providerServices, setProviderServices] = useState([]);
  // Add new service data
  const [resultedServices, setResultedServices] = useState([]);
  // Veg/Non Veg data
  const [mealTypes, setMealTypes] = useState([]);
  // Cuisine Type
  const [cuisines, setCuisines] = useState([]);
  const [cusinemealimagesids, setcusinemealimagesid] = useState([])
  // At top of component
  const [selectedcategory, setselectedcategory] = useState(null)
  const [fetchedevents, setfetchedevents] = useState(null)
  const [editServices, setEditServices] = useState({});
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [loading, setLoading] = useState(true);

  // FIXED: Use ref for fetchProviderServices to break circular dependencies
  const fetchProviderServicesRef = useRef(null);

  // FIXED: Memoize filteredServices
  const filteredServices = useMemo(() => {
    return selectedcategory
      ? providerServices.filter(
        (service) => service.meal?.meal_id === selectedcategory
      )
      : [];
  }, [selectedcategory, providerServices]);

  // FIXED: Memoize API functions
  const fetchMealTypes = useCallback(async () => {
    const mealTypes = await getCateringProviderCategories();

    if (mealTypes) {
      setMealTypes(mealTypes);
      fetchCategories(mealTypes[0]?.meal_id)
    }
  }, []);

  const fetchCategories = useCallback(async (selected_meal_type_id) => {
    const categories = await getCateringCategoryList(selected_meal_type_id);

    if (categories) {
      setCategories(categories);
    }
  }, []);

  const fetchCuisines = useCallback(async () => {
    const cuisines = await getCateringProviderCuisines();

    console.log("cuisines", cuisines);
    if (cuisines) {
      setCuisines(cuisines);
    }

  }, []);

  // FIXED: Initialize fetchProviderServicesRef
  useEffect(() => {
    fetchProviderServicesRef.current = async () => {
      const addedServices = await getCateringProviderAddedServices();
      const fetchedevents = await fetchCategoryEvents()
      console.log("fetchedevents", fetchedevents)
      if (fetchedevents) {
        setfetchedevents(fetchedevents);
      }
      if (addedServices) {
        const formattedServices = addedServices.data.map(service => ({
          ...service,
          regular_price: service.regular_price ? Math.floor(parseFloat(service.regular_price)) : null,
          discounted_price: service.discounted_price ? Math.floor(parseFloat(service.discounted_price)) : null
        }));
        setProviderServices(formattedServices);
        console.log("addedServices.data", addedServices.data);
      }
    };
  }, []);

  useEffect(() => {
    const fetchDropdownData = async () => {
      const masterItems = await getCateringItemMasterList({
        exclude_side_items: false,
      });
      const sidemasterItems = await getCateringItemMasterList({
        exclude_side_items: true,
      });

      console.log("testingdata", masterItems, sidemasterItems);
      sidessetAllMasterItems(
        sidemasterItems?.filter(
          (item) => item?.category?.id !== null && item?.category?.name !== 'Uncategorized'
        ) ?? []
      );

      setAllMasterItems(
        (masterItems ?? [])?.filter(
          (item) => item?.category?.id !== null && item?.category?.name !== 'Uncategorized'
        )
      );

      // const unitTypes = await getCateringUnitTypeList();

      // setUnitTypeList(unitTypes ?? null);
    };

    fetchDropdownData();
  }, []);

  // FIX: Initialize includedItems from resultedServices
  const resultedServicesFunc = useCallback(async () => {
    setLoading(true);
    try {
      const cateringServices = await getCateringProviderServices();
      console.log("cateringServices", cateringServices);
      setResultedServices(cateringServices);
      const getcusinemealimagesids = await getimagesidforcateringcusines()
      if (getcusinemealimagesids) {
        console.log("getcusinemealimagesids", getcusinemealimagesids.data)
        setcusinemealimagesid(getcusinemealimagesids.data)
      }
      // FIX: Initialize includedItems here
      const includedItemsMap = cateringServices?.map((meal) => {
        return {
          meal_id: meal.meal_id,
          meal_name: meal.meal_name,
          defaults: meal.defaults,
          imageid: meal.image?.id || null,
        };
      }) || [];


      console.log("cateringServices includedItemsMap", includedItemsMap)
      setselectedcategory(includedItemsMap[0].meal_id)
      fetchCategories(includedItemsMap[0].meal_id)
      setIncludedItems(includedItemsMap);
    } catch (error) {
      console.error("Failed to services:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Clear edit mode when category changes
  useEffect(() => {
    setEditServices({});
    setShowCreateForm(false);
  }, [selectedcategory]);

  useEffect(() => {
    fetchMealTypes();
    fetchCuisines();
    if (fetchProviderServicesRef.current) {
      fetchProviderServicesRef.current();
    }
    resultedServicesFunc();
  }, [fetchMealTypes, fetchCuisines, resultedServicesFunc]);

  // FIXED: Memoize all handler functions
  const handleDelete = useCallback(async (itemId) => {
    setLoading(true);
    const toDeleteService = {
      itemIds: [itemId],
    };

    try {
      await deleteCateringProviderServices(toDeleteService);
      console.log('✅ Service deleted successfully');
      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }
    } catch (error) {
      console.error("Failed to delete service:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteServiceConfirm = useCallback((serviceID) => {
    confirmDialog({
      message: "Do you want to delete this service?",
      header: "Delete Confirmation",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept: () => handleDelete(serviceID),
      reject,
    });
  }, [handleDelete]);

  const reject = useCallback(() => { }, []);

  const handleEdit = useCallback((serviceId) => {
    console.log('🔍 [handleEdit] Editing service ID:', serviceId);
    setEditServices(prev => ({
      [serviceId]: true
    }));
    console.log('scrollY before:', window.scrollY);

    // Use setTimeout to ensure state update and DOM rendering happens first
    setTimeout(() => {
      window.scrollTo({
        top: 450,
        behavior: 'smooth'
      });
    }, 100);
  }, []);

  // FIXED: Create service with proper dependencies
  const handleCreateService = useCallback(async (formData) => {
    try {
      console.log('🔧 [handleCreateService] Creating service with data:', formData);

      // Map cuisine category names to IDs
      const mapCuisineCategoryToId = (cuisineCategory) => {
        if (!cuisineCategory) return null;
        const name = cuisineCategory.name || cuisineCategory;
        switch (name.toLowerCase()) {
          case 'vegetarian':
          case 'veg':
            return 1;
          case 'non-vegetarian':
          case 'non vegetarian':
          case 'nonveg':
          case 'non-veg':
            return 2;
          default:
            return null;
        }
      };

      // Function to find item and get cuisine category
      const findItemCuisineCategory = (itemName, itemId) => {
        // Search in allMasterItems
        for (const categoryGroup of allMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        // Search in sidessallMasterItems
        for (const categoryGroup of sidessallMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        return null;
      };

      // Determine the main category_id based on included items
      const determineMainCategoryId = () => {
        // Check all included items
        for (const item of formData.included_items) {
          const cuisineCategory = findItemCuisineCategory(item.itemName, item.itemId);
          const categoryId = mapCuisineCategoryToId(cuisineCategory);
          if (categoryId) {
            return categoryId; // Return the first valid category found
          }
        }

        // Check side items if no category found in main items
        for (const item of formData.included_side_items) {
          const cuisineCategory = findItemCuisineCategory(item.itemName, item.itemId);
          const categoryId = mapCuisineCategoryToId(cuisineCategory);
          if (categoryId) {
            return categoryId;
          }
        }

        return null; // Return null if no category found
      };

      // Remove item_id for create operations
      const { item_id, ...createData } = formData;

      const finalCreateData = {
        ...createData,
        category_id: determineMainCategoryId(), // Set main category_id here
        type_id: Number(formData.type_id || 1),
        meal_id: Number(selectedcategory),
        image_ids: formData.image_ids ?? [],
        included_items: formData.included_items
          .filter(item => item.itemName && item.qty)
          .map(item => ({
            itemName: item.itemName,
            qty: parseInt(item.qty) || 1,
            itemId: item.itemId || null,
            unitType: null,
          })),
        event_ids: formData.event_ids || [],
      };

      console.log('🔧 [handleCreateService] Final create data:', finalCreateData);

      const response = await addCateringProviderServices(finalCreateData);
      console.log('✅ Service created successfully:', response);

      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }
      setShowCreateForm(false);

    } catch (error) {
      console.error('❌ Error creating service:', error);
    }
  }, [selectedcategory, allMasterItems, sidessallMasterItems]);

  const handleEditService = useCallback(async (formData) => {
    try {
      console.log('🔧 [handleEditService] Updating service with data:', formData);

      // Map cuisine category names to IDs
      const mapCuisineCategoryToId = (cuisineCategory) => {
        if (!cuisineCategory) return null;
        const name = cuisineCategory.name || cuisineCategory;
        switch (name.toLowerCase()) {
          case 'vegetarian':
          case 'veg':
            return 1;
          case 'non-vegetarian':
          case 'non vegetarian':
          case 'nonveg':
          case 'non-veg':
            return 2;
          default:
            return null;
        }
      };

      // Function to find item and get cuisine category
      const findItemCuisineCategory = (itemName, itemId) => {
        // Search in allMasterItems
        for (const categoryGroup of allMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        // Search in sidessallMasterItems
        for (const categoryGroup of sidessallMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        return null;
      };

      // Determine the main category_id based on included items
      const determineMainCategoryId = () => {
        // Check all included items
        for (const item of formData.included_items) {
          const cuisineCategory = findItemCuisineCategory(item.itemName, item.itemId);
          const categoryId = mapCuisineCategoryToId(cuisineCategory);
          if (categoryId) {
            return categoryId; // Return the first valid category found
          }
        }


        return null; // Return null if no category found
      };

      const updateData = {
        item_id: formData.item_id,
        meal_id: selectedcategory,
        type_id: formData.type_id,
        category_id: determineMainCategoryId(), // Set main category_id here
        custom_combo_name: formData.custom_combo_name,
        description: formData.description || null,
        regular_price: parseFloat(formData.regular_price) || 0,
        discounted_price: formData.discounted_price !== null && formData.discounted_price !== ''
          ? parseFloat(formData.discounted_price)
          : null,
        valid_until: formData.valid_until || null,
        included_items: formData.included_items
          .filter(item => item.itemName && item.qty)
          .map(item => ({
            itemName: item.itemName,
            qty: parseInt(item.qty) || 1,
            itemId: item.itemId || null,
            unitType: null,
            catering_item_id: item.catering_item_id || null,
          })),
        image_ids: formData.image_ids ?? [],
        event_ids: formData.event_ids || [],
      };
      console.log("updatecateringdate", updateData)
      const response = await updateCateringProviderServices(updateData);

      // Refresh services after manual submit
      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }

      // Exit edit mode after successful submission
      setEditServices(prev => {
        const newState = { ...prev };
        delete newState[formData.item_id];
        return newState;
      });

    } catch (error) {
      console.error('❌ Error updating service:', error);
    }
  }, [selectedcategory, allMasterItems, sidessallMasterItems]);

  const handleFormSubmit = useCallback((formData, isEditMode = false) => {
    console.log('[handleFormSubmit] Received formData:', {
      isEditMode,
      item_id: formData.item_id,
      serviceName: formData.custom_combo_name
    });

    const hasNonVeg = includedItems.some(includedItem => {
      // Find the corresponding master item
      const masterItem = allMasterItems.find(master => master.itemId === includedItem.itemId);

      // If master item is found and it's non-veg, return true
      return masterItem && masterItem.isVeg === false; // or whatever property indicates non-veg
    });

    // Set category_id based on the check
    formData.category_id = hasNonVeg ? 2 : 1;
    if (isEditMode) {
      handleEditService(formData);
    } else {
      handleCreateService(formData);
    }
  }, [handleEditService, handleCreateService]);

  // FIXED: Memoize all other handlers
  const handleCreateNew = useCallback(() => {
    setShowCreateForm(true);
    window.scrollTo({
      top: 450,
      behavior: 'smooth'
    });
  }, []);

  const handleFormCancel = useCallback(() => {
    setShowCreateForm(false);
  }, []);

  const handleCancel = useCallback((serviceId) => {
    setEditServices(prev => {
      const newState = { ...prev };
      delete newState[serviceId];
      return newState;
    });
  }, []);

  const isServiceEditing = useCallback((serviceId) => {
    return !!editServices[serviceId];
  }, [editServices]);

  // Check if any service is being edited
  const isAnyServiceEditing = useMemo(() => {
    return Object.values(editServices).some(editing => editing);
  }, [editServices]);

  // FIXED: Memoize ServiceForm props to prevent unnecessary re-renders
  const getServiceFormProps = useCallback((service, isEditing) => ({
    isPackageMode: true,
    service: service,
    onSubmit: handleFormSubmit,
    cuisines: cuisines,
    onCancel: () => handleCancel(service.item_id),
    categories: includedItems,
    types: mealTypes,
    includedItemsList: providerServices,
    itemsCategories: categories,
    allMasterItems: allMasterItems,
    sidessallMasterItems: sidessallMasterItems,
    isEditing: isEditing,
    onToggleEdit: () => handleEdit(service.item_id), // This passes the service.item_id to handleEdit
    selectedcategory: selectedcategory,
    fetchedevents: fetchedevents
  }), [
    handleFormSubmit,
    handleCancel,
    handleEdit,
    includedItems,
    mealTypes,
    providerServices,
    allMasterItems,
    sidessallMasterItems,
    selectedcategory,
    fetchedevents
  ]);

  return (
    <>
      <div className={caterStyles.cateringcontainer}>

        {loading ? (
          <div>
            <h3 style={{ textAlign: "center" }}>
              <i
                className="pi pi-spin pi-spinner-dotted"
                style={{ fontSize: "2rem", color: "#0cc0df" }}
              ></i>
            </h3>
          </div>
        ) : (
          <>
            {/* Left category */}
            {/* !isAnyServiceEditing &&  */}

            <div className={caterStyles.backgroundImage}></div>

            <div className={caterStyles.leftcontainer}>
              {includedItems.length > 0 ? (
                includedItems.map((item) => {
                  // Find the corresponding image data for this meal_id
                  const mealImageData = cusinemealimagesids?.find(
                    (imageItem) => imageItem.meal_id === item.meal_id
                  );
                  //  console.log("gugugu", item);
                  // Get the image URL if available
                  const imageUrl = item?.imageid
                    ? `${config.API_BASE_URL}/gallery/download/${item.imageid}`
                    : noimage;

                  return (
                    <div
                      key={item.meal_id}
                      className={
                        selectedcategory === item.meal_id
                          ? `${caterStyles.showitemswithimage} ${caterStyles.active}`
                          : caterStyles.showitemswithimage
                      }
                      onClick={() => {
                        setselectedcategory(item.meal_id);
                        fetchCategories(item.meal_id);
                      }}
                    >
                      <img
                        src={imageUrl}
                        alt={item.meal_name}
                        className={caterStyles.imagesize}
                        onError={(e) => {
                          // Fallback to noimage if the API image fails to load
                          e.target.src = noimage;
                        }}
                      />
                      <div className={caterStyles.itemLabel}>{item.meal_name}</div>
                    </div>
                  );
                })
              ) : (
                <p>No meal categories available</p>
              )}
            </div>

            {/* Right content */}
            <div className={caterStyles.rightcontainer}>
              <div className={caterStyles.rightcontainerwrapper}>
                {selectedcategory ? (
                  <>
                    {/* Global Header for Edit/Create mode */}
                    {(isAnyServiceEditing || showCreateForm) && (
                      <div className={caterStyles.globalHeader}>
                        <button
                          type="button"
                          onClick={() => {
                            if (isAnyServiceEditing) {
                              // Find the service being edited and cancel it
                              const editingServiceId = Object.keys(editServices).find(id => editServices[id]);
                              if (editingServiceId) {
                                handleCancel(editingServiceId);
                              }
                            } else if (showCreateForm) {
                              handleFormCancel();
                            }
                          }}
                          className={caterStyles.backButton}
                          title="Go back"
                        >
                          <i className="pi pi-arrow-left"></i>
                        </button>
                        <span className={caterStyles.globaltext}>
                          {isAnyServiceEditing ? 'Edit Your Package' : 'Create Your Menu'}
                        </span>
                      </div>
                    )}

                    {/* Add New Service Button - Show when not in create mode and no service is being edited */}
                    {!showCreateForm && !isAnyServiceEditing && (
                      <div className={caterStyles.addNewContainer}>
                        <button
                          onClick={handleCreateNew}
                          className={caterStyles.addNewBtn}
                        >
                          <i className="pi pi-plus" style={{ fontSize: "12px" }}></i> Add my own menu
                        </button>
                      </div>
                    )}

                    {/* Show create form when creating new service */}
                    {showCreateForm && (
                      <ServiceForm
                        isPackageMode={true}
                        fetchedevents={fetchedevents}
                        onSubmit={handleFormSubmit}
                        onCancel={handleFormCancel}
                        categories={includedItems}
                        itemsCategories={categories}
                        cuisines={cuisines}
                        types={mealTypes}
                        includedItemsList={providerServices}
                        allMasterItems={allMasterItems}
                        sidessallMasterItems={sidessallMasterItems}
                        selectedcategory={selectedcategory}
                        mode="create"
                      />
                    )}

                    {/* Show existing service cards */}
                    <div className={caterStyles.totalcards}>
                      {!showCreateForm && filteredServices.length > 0 ? (
                        filteredServices.map((service) => {
                          const isEditing = isServiceEditing(service.item_id);
                          const serviceFormProps = getServiceFormProps(service, isEditing);

                          // Create delete button component - only show in view mode
                          const deleteButton = !isEditing ? (
                            <button
                              onClick={() => deleteServiceConfirm(service.item_id)}
                              className={caterStyles.deleteBtn}
                              title="Delete this service"
                            >
                              <DeleteTwoToneIcon fontSize="small" /> Delete
                            </button>
                          ) : null;

                          // If any service is in edit mode, only show the one being edited
                          if (isAnyServiceEditing && !isEditing) {
                            return null; // Don't show other services when one is being edited
                          }

                          return (
                            <div key={service.item_id} className={isEditing ? caterStyles.editserviceCardWrapper : caterStyles.serviceCardWrapper}>
                              <ServiceForm
                                {...serviceFormProps}
                                deleteButton={deleteButton}
                                mode={isEditing ? "edit" : "view"} // Pass mode as prop
                              />
                            </div>
                          );
                        })
                      ) : (
                        !showCreateForm && !isAnyServiceEditing &&
                        <div className={caterStyles.nopackagetext}>

                          <span>No Package Created</span>
                          <span>Please click on add my package to create your own menu.</span>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <p>Click the menu to create your Package</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default React.memo(CateringService);